import observer from 'saddlebag-observer';

import {
  SET_DIRECTNESS_FILTER_ENABLED,
  SET_INITIAL_DIRECTNESS_FILTER,
  TRIGGER_SET_DIRECTNESS_FILTER,
} from '../helpers/constants/actionsConstants';

import type { DirectnessFilterAction } from '../actions/types';
import type { DirectnessFilterState } from '../selectors/types';

const initialState: DirectnessFilterState = {
  filtering: false,
  initialFiltering: false,
  enabled: true,
};

const reducer = (
  state: DirectnessFilterState = initialState,
  action: DirectnessFilterAction,
): DirectnessFilterState => {
  switch (action.type) {
    case SET_INITIAL_DIRECTNESS_FILTER:
      return {
        ...state,
        filtering: action.payload,
        initialFiltering: action.payload,
      };

    case `${TRIGGER_SET_DIRECTNESS_FILTER}_STARTED`: {
      observer.publish('toggle-directness', action.payload);

      return {
        ...state,
        filtering: action.payload,
      };
    }

    case SET_DIRECTNESS_FILTER_ENABLED:
      return {
        ...state,
        enabled: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
